import * as React from "react";
import { connect } from "react-redux";
import { Redirect, RouteProps } from "react-router-dom";

import { IState } from "../../state/modules";
import AuthSelectors from "../../state/modules/auth/AuthSelectors";
import { InitialLoadingScreen } from "./InitialLoadingScreen";
import NavigationConstants from "./NavigationConstants";

interface IProps extends RouteProps {
  isSignedIn?: boolean;
  didRefreshAuth?: boolean;
}

@(connect(
  (state: IState, ownProps: IProps): Partial<IProps> => ({
    isSignedIn: AuthSelectors.isSignedIn(state.auth),
    didRefreshAuth: AuthSelectors.didRefreshAuth(state.auth)
  })
) as any)
export default class AuthedContainer extends React.Component<IProps> {
  public render() {
    const { isSignedIn, didRefreshAuth } = this.props;
    const { location } = this.props;

    if (!didRefreshAuth) {
      return <InitialLoadingScreen />;
    } else if (isSignedIn) {
      return this.props.children;
    } else {
      return (
        <Redirect
          to={{
            pathname: NavigationConstants.login,
            state: { from: location }
          }}
        />
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Navigation/AuthedContainer.tsx